export function successSnackbarOptions() {
    return {
        position: 'bottom-right',
        style: {
            color: "#ffffff",
            backgroundColor: "#318500",
            position: "fixed",
            bottom: "20px",
            right: "1%",
            minWidth: "280px",
            maxWidth: "60vw",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap"
        }
    };
}

export function warningSnackbarOptions() {
    return {
        position: 'bottom-right',
        style: {
            color: "#ffffff",
            backgroundColor: "#F2AF17",
            position: "fixed",
            bottom: "20px",
            right: "1%",
            minWidth: "280px",
            maxWidth: "60vw",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap"
        }
    };
}

export function errorSnackbarOptions() {
    return {
        position: 'bottom-right',
        style: {
            color: "#ffffff",
            backgroundColor: "#c71f25",
            position: "fixed",
            bottom: "20px",
            right: "1%",
            minWidth: "280px",
            maxWidth: "60vw",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap"
        }
    };
}

export function infoSnackbarOptions() {
    return {
        position: 'bottom-right',
        style: {
            color: "#ffffff",
            backgroundColor: "#2196f3", // blue info color
            position: "fixed",
            bottom: "20px",
            right: "1%",
            minWidth: "280px",
            maxWidth: "60vw",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap"
        }
    };
}

export function warningScrollingSnackbarOptions() {
    return {
        position: 'bottom-right',
        style: {
            background: "#fb832dff",
            border: "1px solid #fb832dff",
            borderRadius: "8px",
            padding: "12px",
            fontSize: "14px",
            color: "#fb832dff",
            maxWidth: "60vw",
            minWidth: "300px",
            boxSizing: "border-box",
            resize: "both",
            overflow: "hidden" 
    }
  };
}

